module.exports = __webpack_public_path__ + "static/media/tour-completion-img.b362ad07.png";